import gql from 'graphql-tag'
export default gql`query chlorideClassesQuery {
  chlorideClasses {
    code
    description
    maxChloride
    id
  }
}`